import { addDays, startOfDay } from "date-fns";

/**
 * How far ahead the calendar may be navigated.
 *
 * The technician calendar is a day-of-work tool, not a planner: further-out schedules
 * are still being moved by dispatch and route optimization, so showing them invites a
 * technician to plan around something that will not hold.
 */
export const MAX_DAYS_AHEAD = 3;

/** The furthest day that may be displayed, as a local day boundary. */
export const latestSelectableDate = (): Date => addDays(startOfDay(new Date()), MAX_DAYS_AHEAD);

export const isBeyondForwardLimit = (date?: Date | null): boolean =>
  !!date && startOfDay(date) > latestSelectableDate();

/** True once the displayed day is the last one allowed — the "next" control is spent. */
export const isAtForwardLimit = (date?: Date | null): boolean => !!date && startOfDay(date) >= latestSelectableDate();
